import i18next from 'i18next';

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'notification-ui', {
    deploySuprSendWorkflows: 'Deploy SuprSend workflows',
    deploySuprSendWorkflowsDialogTitle: 'Deploy SuprSend Workflows',
    deploy: 'Deploy',
    sourceWorkspace: 'Source workspace',
    targetWorkspace: 'Target workspace',
    notificationNotFound: 'Notification not found.',
    notification: 'Notification',
    channels: 'Channels',
    notificationServiceNotConfigured:
      'Notification preferences are not available: the notification service is not configured (missing NEXT_PUBLIC_SUPRSEND_PUBLIC_KEY).',
    tabNotificationsDescription:
      'You can choose which notifications to receive and how (email, SMS (text message), push notifications, etc.). Scroll to the bottom to turn off all notifications for a channel. Please note that currently only Important System Messages and Habit Reminders are implemented.',
    notificationChannels: 'Notification Channels',
    noData: 'No Data',
    sendNotification: 'Send Notification',
    send: 'Send',
    recipientEmail: 'Recipient email',
    workflow: 'Workflow',
    sendNotificationToUser: 'Send a notification to {{userName}}',
    sendNotificationToThisUser: 'Send a notification to this user',
    sendNotificationToEmail: 'Send a notification to an email address (no user account required)',
    enterValidEmailAddress: 'Enter a valid email address',
    notificationRequestSubmitted: 'Notification request submitted successfully.',
    failedToSendNotification: 'Failed to send notification.',
  });
}
